module.exports = __webpack_public_path__ + "static/TMD 2 intraoral before-d0b47164b81d45d27f62eeafc754fd81.jpg";